//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      levelList: null,
    };
  },
  computed: {
    ...mapGetters({
      breadcrumbList: 'user/getBreadcrumb',
    }),
    visibleLevelList() {
      if (this.breadcrumbList.length) {
        return this.breadcrumbList;
      }
      if (this.levelList.length) {
        return this.levelList
          .filter(function (level) {
            return level.meta.title;
          })
          .map((item) => {
            return {
              path: item.path,
              redirect: item.redirect,
              title: item.meta.title,
            };
          });
      }
      return [];
    },
  },
  watch: {
    $route() {
      this.setBreadcrumb([]);
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    ...mapMutations({
      setBreadcrumb: 'user/setBreadcrumb',
    }),
    getBreadcrumb() {
      const matched = this.$route.matched.filter((item) => item.name);
      this.levelList = matched;
    },
  },
};
